import { useQuery } from "@tanstack/react-query";
import { api } from "../../../api";
import type { BuildDetail, BuildListItem } from "../types/build";

export function useBuilds(
  workspaceId: string | undefined,
  repository: string,
  cursor?: string,
  view: "latest" | "branch-or-tag" = "latest",
) {
  const query = new URLSearchParams({ limit: "50" });
  if (repository) {
    query.set("repository", repository);
  }
  if (cursor) {
    query.set("cursor", cursor);
  }

  return useQuery({
    queryKey: ["builds", view, workspaceId, repository, cursor],
    queryFn: () =>
      api<{ items: BuildListItem[]; nextCursor: string | null }>(
        `/${workspaceId}/builds${view === "branch-or-tag" ? "/branches-latest" : ""}?${query.toString()}`,
      ),
  });
}

export function useBuild(
  buildId: string | undefined,
  workspaceId: string | undefined,
) {
  return useQuery({
    enabled: Boolean(buildId && workspaceId),
    queryKey: ["build", workspaceId, buildId],
    queryFn: () => api<BuildDetail>(`/${workspaceId}/builds/${buildId}`),
  });
}
